module.exports = __webpack_public_path__ + "static/media/trim-hq-t.5cb05fc3.png";